import { CalendarWideFilterItem } from "./CalendarWideFilterItem";

export class CalendarWideFilter{

    filterItems : Array<CalendarWideFilterItem>

}